import { DashboardService } from '@common/lib/api';
import to from '@common/lib/common/to';
import * as dashboard from './types';
//import * as common from '@common/store/modules/common/types';
//import * as commonGetters from '@common/store/modules/common/getters';

const actions = {
  async [dashboard.FETCH_STATISTICS](context, params) {
    const { data } = await DashboardService.searchStatistics(params);
    context.commit(dashboard.SET_STATISTICS, data);
    return data;
  },
};

export default actions;
